import { render } from "./InfoImgDialog.vue?vue&type=template&id=aab375e2&scoped=true"
import script from "./InfoImgDialog.vue?vue&type=script&lang=js"
export * from "./InfoImgDialog.vue?vue&type=script&lang=js"

import "./InfoImgDialog.vue?vue&type=style&index=0&id=aab375e2&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab375e2"]])

export default __exports__